import { Logger } from "../../util/log/Logger";
import { DataObject } from "../core/data/DataObject";
/**
 * SetSettingsParams.ts
 */
export class SetSettingsParams {
    constructor(roomName, extraSpin, spinPrice, singleGameStake, maximumLoss, hideInstructions) {
        this.roomName = roomName;
        this.extraSpin = extraSpin;
        this.spinPrice = spinPrice;
        this.singleGameStake = singleGameStake;
        this.maximumLoss = maximumLoss;
        Logger.forceLog("SetSettingsParams: " + hideInstructions);
        this.hideInstructions = hideInstructions;
    }
    liquify() {
        return new DataObject(this);
    }
}
//# sourceMappingURL=SetSettingsParams.js.map